import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-565e0599"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pe-empty" }
const _hoisted_2 = { class: "pe-empty_desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`pe-empty_image pe-empty_image-${_ctx.image}`)
    }, null, 2),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.desc), 1)
  ]))
}